import React, { useState, useRef, useEffect } from 'react'
import styles from './gallery.module.scss'

interface Props {
  images: string[]
  currentIndex: number
  onThumbnailClick: (index: number) => void
  isMobile: boolean
}

export default function ThumbnailCarousel({
  images,
  currentIndex,
  onThumbnailClick,
  isMobile,
}: Props) {
  const duplicatedImages = isMobile ? [...images, ...images, ...images] : images
  const offset = isMobile ? images.length : 0
  const activeThumbnailIndex = isMobile ? currentIndex + offset : currentIndex

  const containerRef = useRef<HTMLDivElement>(null)
  const [visibleCount, setVisibleCount] = useState(0)
  const thumbnailWidth = 101

  useEffect(() => {
    const updateVisibleCount = () => {
      if (containerRef.current) {
        const containerWidth = containerRef.current.offsetWidth
        setVisibleCount(Math.floor(containerWidth / thumbnailWidth))
      }
    }

    updateVisibleCount()
    window.addEventListener('resize', updateVisibleCount)

    return () => {
      window.removeEventListener('resize', updateVisibleCount)
    }
  }, [])

  const getTranslateValue = () => {
    const startOffset = Math.max(0, currentIndex - visibleCount + 2)
    return -startOffset * thumbnailWidth
  }

  const handleThumbnailClick = (index) => {
    // Adjust index based on duplication offset
    const realIndex = index % images.length
    onThumbnailClick(realIndex)
  }

  return (
    <div className={styles.gallery__thumbnails_container} ref={containerRef}>
      <div
        className={styles.gallery__thumbnails}
        style={{
          transform: `translateX(${getTranslateValue()}px)`,
          transition: 'transform 0.3s ease-in-out',
        }}>
        {duplicatedImages.map((img, index) => (
          <button
            key={index}
            className={`${styles.gallery__thumbnail} ${
              index === currentIndex ? styles.active : ''
            }`}
            onClick={() => handleThumbnailClick(index)}
            style={{
              // Center the active thumbnail in the loop (adjust based on your layout)
              transform:
                isMobile && index === activeThumbnailIndex
                  ? 'scale(1.1)'
                  : 'none',
            }}>
            <img src={img} alt={`Thumbnail ${index + 1}`} />
          </button>
        ))}
      </div>
    </div>
  )
}
